import * as types from '../mutation-types';
import api from '@/store/utils/api';

const state = {
    currentQuickQualification: {},
};

const getters = {
    currentQuickQualification: state => state.currentQuickQualification,
};

const actions = {
    getQuickQualification({ commit }, payload) {
        return api.get(`/clients/${payload.client}/quick-qualifications/${payload.guid}/`).then(res => {
            commit(types.UPDATE_CURRENT_QUICK_QUALIFICATION, res);
            return res;
        });
    },
    patchQuickQualification({ commit }, payload) {
        return api.patch(`/clients/${payload.clientId}/quick-qualifications/${payload.guid}/`, payload).then(res => {
            commit(types.UPDATE_CURRENT_QUICK_QUALIFICATION, res);
            return res;
        });
    },
    createQuickQualification({ commit }, payload) {
        const apiUrl = `/clients/${payload.clientId}/quick-qualifications/`;
        return api
            .post(apiUrl, payload)
            .then((res) => {
                commit(types.UPDATE_CURRENT_QUICK_QUALIFICATION, res);
                return res;
            });
    },
};

const mutations = {
    [types.UPDATE_CURRENT_QUICK_QUALIFICATION](state, payload) {
        state.currentQuickQualification = payload;
    },
};

export default {
    namespaced: true,
    getters,
    state,
    actions,
    mutations,
};
